const IocTypes = {
  Repository: Symbol.for("Repository"),
  DataService: Symbol.for("DataService"),
  ValidationService: Symbol.for("ValidationService"),
  SidebarService: Symbol.for("SidebarService"),
  DashboardService: Symbol.for("DashboardService"),
  FileService: Symbol.for("FileService"),
  PersistentLog: Symbol.for("PersistentLog"),
  ValidationRuleService: Symbol.for("ValidationRuleService"),
  ContentDialogService: Symbol.for("ContentDialogService"),
  RequirementCreateService: Symbol.for("RequirementCreateService"),
  RequirementFormService: Symbol.for("RequirementFormService"),
  SelfReadingFormService: Symbol.for("SelfReadingFormService"),
  DataFilterHandler: Symbol.for("DataFilterHandler"),
  DataFilterStateHandler: Symbol.for("DataFilterStateHandler"),
  PaginationHandler: Symbol.for("PaginationHandler"),
  PaginationStateHandler: Symbol.for("PaginationStateHandler"),
  SortingStateHandler: Symbol.for("SortingStateHandler"),
  SortingStoreHandler: Symbol.for("SortingStoreHandler"),
  ComplaintFormService: Symbol.for("ComplaintFormService"),
  AddressService: Symbol.for("AddressService"),
  AddressFormService: Symbol.for("AddressFormService"),
  DataFilterService: Symbol.for("DataFilterService"),
  DataGridService: Symbol.for("DataGridService"),
  DistRateCircuitBreakerFormService: Symbol.for("DistRateCircuitBreakerFormService"),
  ReservedCapacityFormService: Symbol.for("ReservedCapacityFormService"),
  PaymentMethodFormService: Symbol.for("PaymentMethodFormService"),
  BankAccountValidator: Symbol.for("BankAccountValidator"),
  SipoValidator: Symbol.for("SipoValidator"),
  AdvanceFormService: Symbol.for("AdvanceFormService"),
  MessagesService: Symbol.for("MessagesService"),
  DataHelper: Symbol.for("DataHelper"),
  InvoiceService: Symbol.for("InvoiceService"),
  FileValidator: Symbol.for("FileValidator"),
  ReservedCapacityGasFormService: Symbol.for("ReservedCapacityGasFormService"),
  CustomerService: Symbol.for("CustomerService"),
  AresService: Symbol.for("AresService"),
};

export { IocTypes };